import { ApolloClient, InMemoryCache } from '@apollo/client';
import ENV from './env';

export const gcmsClient = new ApolloClient({
  uri: ENV.websiteApiUrl,
  cache: new InMemoryCache(),
  connectToDevTools: false,
});
